import { Navigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { SalesDashboard } from '../sales/SalesDashboard';

/**
 * The "/" route is persona-dependent:
 *   sales_girl (has homeShopId)  → SalesDashboard (her shop)
 *   owner / admin / finance / ops → FinanceDashboard (cross-shop)
 *   anything else                 → SalesDashboard (the catalogue is the safest default)
 */
export function AutoLanding(): JSX.Element {
  const { user, perms } = useAuth();
  if (!user) return <SalesDashboard />;

  const isShopFloor = user.role === 'sales_girl' && !!user.homeShopId;
  const canSeeFinance = perms.has('finance.view_dashboard');

  if (!isShopFloor && canSeeFinance) {
    return <Navigate to="/finance" replace />;
  }
  return <SalesDashboard />;
}
